import { useEffect } from "react";
import { useLocation } from "react-router";
import { matchRoutes } from "react-router-config";
import { useDispatch } from "react-redux";
import { updateModuleName } from "@App/appReducer";
import {
  persistEngageAttributionFromUrl,
  registerPostHogSuperProperties,
  trackRoutePageView,
} from "@Utils/posthog";
import { APP_PAGE } from "@Utils/webApputils/analyticEvents";

// Pages that handle their own page_viewed event (e.g. AB test variants with different screen names)
const SELF_TRACKED_PAGES = [APP_PAGE.SCHOLARSHIP];

const DataLayout = (props: any) => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const { routes } = props;
    const routeData = matchRoutes(routes, location.pathname).reduce(
      (res: any, { route, match }: any) => {
        if (match.isExact) {
          return { route, match };
        }
        return res;
      },
      null,
    );

    persistEngageAttributionFromUrl();
    registerPostHogSuperProperties().catch(() => undefined);

    const moduleName = routeData?.route?.moduleName;
    if (moduleName) {
      // @ts-ignore
      window.moduleName = moduleName;
      dispatch(updateModuleName(moduleName));
      if (!SELF_TRACKED_PAGES.includes(moduleName)) {
        trackRoutePageView(moduleName);
      }
    }

    if (routeData?.route?.prefetch) {
      setTimeout(() => {
        routeData?.route?.prefetch?.forEach((it: any) => {
          it.preload();
        });
      }, 1000);
    }
  }, [location.pathname]);

  return <></>;
};

export default DataLayout;
